import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import Container from '../Container';
import FancyTitle from '../fancy-title';
import StoryblokImage from './storyblok-image';

function ShopifyCertificates({ blok }) {
  const title = blok?.title || '';
  const description = blok?.description || '';
  const certificates = Array.isArray(blok?.certificates) ? blok.certificates : [];
  return (
    <div {...storyblokEditable(blok)}>
      <Container>
        {title && (
          <FancyTitle
            text={title}
            tag="h2"
            textAlign="text-left"
            className={"mb-5"}
          />
        )}

        {description && (
          <p className="first-of-type:mt-0 last-of-type:mb-0 m-auto my-4  text-left" style={{ fontSize: '16px' }}>
            {description}
          </p>
        )}

        {certificates.length > 0 && (
          <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-8 items-center">
            {certificates.map((asset) => (
              <StoryblokImage
                key={asset?.filename || asset?.id || JSON.stringify(asset)}
                src={asset}
                className="w-full h-auto object-contain"
                imageClassName="!m-0 block"
                ratio="auto"
                figured={false}
                sizes="(max-width: 500px) 45vw, (max-width: 1024px) 30vw, 25vw"
              />
            ))}
          </div>
        )}
      </Container>
    </div>
  );
}

export default ShopifyCertificates;
